import { useDispatch, useSelector } from "react-redux";
import { clearUser } from "../../store/slices/UserSlice";
import { useParams, generatePath } from "react-router-dom";
import logo from "../../assets/img/hlogo.png";
import userIcon from "../../assets/img/UserImage.png";
import { Persona, PersonaSize } from "@fluentui/react";

const Header = () => {
  // redux state
  const { userObj } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const { clientName } = useParams();

  const isClientValid =
    typeof clientName === "string" &&
    clientName.trim() !== "" &&
    clientName !== null &&
    clientName !== undefined;

  if (!userObj && isClientValid) {
    window.location.href = generatePath("/client/:clientName/", {
      clientName,
    });
    return;
  }

  const personaProps = {
    imageUrl: userObj?.imageUrl ? userObj?.imageUrl : userIcon, // Replace with your image URL
   // text: userObj?.userName, // User's name
    //secondaryText: 'john.doe@example.com', // User's email
  
  };
  return (
    <>
      <nav className="navbar navbar-expand-lg bg-darkBlue dashboard_nav p-0 px-5">
        <div className="w-100 d-flex gap-3 mt-3">
          <img src={logo} className="logoheader " alt="logo" />
          {isClientValid ? (
            <>
              <p
                className="mt-3 "
                style={{
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                Hello, {userObj?.userName}
              </p>
            </>
          ) : null}
        </div>
        <div className="w-100 d-flex align-items-center justify-content-end gap-3 mt-3">
          {isClientValid && (
            <div
              className="d-flex nav-user align-items-center"
              style={{ gap: "10px" }}
            >
              {/* <p className="mb-0">{userObj?.userEmail}</p> */}

              <div>
                {isClientValid ? (
                  <>
                    <div>
                      <Persona
                        {...personaProps}
                        size={PersonaSize.size32} // Adjust size as needed
                        imageAlt="User profile picture"
                      />
                    </div>
                  </>
                ) : null}
              </div>
              <i
                className="fa fa-solid fa-right-from-bracket"
                title="Logout"
                onClick={() => dispatch(clearUser())}
                style={{cursor:"pointer"}}
              ></i>
            </div>
          )}
        </div>
      </nav>
    </>
  );
};
export default Header;
